import { defineMessages } from 'react-intl';

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.title',
        defaultMessage: 'Skonfiguruj parafię, kontakty parafialne i subskrypcję',
    },
    secondaryTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.secondaryTitle',
        defaultMessage: '',
    },
    cancelSetup: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.cancelSetup',
        defaultMessage: 'Zamknij konfigurację',
    },
    finishSetup: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.finishSetup',
        defaultMessage: 'Zakończ konfigurację',
    },
    closeSetup: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.closeSetup',
        defaultMessage: 'Wyjdź z konfiguracji',
    },
    closeModalTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.closeModalTitle',
        defaultMessage: 'Czy na pewno chcesz zamknąć konfigurację?',
    },
    closeModalDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.closeModalDescription',
        defaultMessage: 'Po zamknięciu możesz zapisać dane i wrócić do konfiguracji później.',
    },
    groupStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.groupStepTitle',
        defaultMessage: 'Utwórz parafię',
    },
    groupName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.groupName',
        defaultMessage: 'Nazwa grupy',
    },
    parishName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.parishName',
        defaultMessage: 'Nazwa parafii',
    },
    website: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.website',
        defaultMessage: 'Strona internetowa',
    },
    parishWebsite: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.parishWebsite',
        defaultMessage: 'Strona internetowa parafii',
    },
    categoriesStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.categoriesStepTitle',
        defaultMessage: 'Role i funkcje w kontaktach parafialnych',
    },
    categoriesDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.categoriesDescription',
        defaultMessage: 'Domyślne role i funkcje zostały dodane. Możesz je edytować lub rozszerzyć. Ten krok jest opcjonalny.',
    },
    newCategory: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.newCategory',
        defaultMessage: 'Nowa rola lub funkcja',
    },
    categoriesDuplicatedTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.categoriesDuplicatedTitle',
        defaultMessage: 'Powtarzające się role lub funkcje',
    },
    categoriesDuplicatedSubtitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.categoriesDuplicatedSubtitle',
        defaultMessage: 'Nazwy ról i funkcji muszą być unikalne.',
    },
    peopleStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.peopleStepTitle',
        defaultMessage: 'Osoby w kontaktach parafialnych',
    },
    combinedPeopleStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.combinedPeopleStepTitle',
        defaultMessage: 'Role, funkcje i osoby w kontaktach parafialnych',
    },
    peopleDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.peopleDescription',
        defaultMessage: 'Dodaj osoby i przypisz je do wybranych ról lub funkcji. Ten krok jest opcjonalny.',
    },
    addPeopleTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.addPeopleTitle',
        defaultMessage: 'Dodaj osoby',
    },
    currentPeopleTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.currentPeopleTitle',
        defaultMessage: 'Aktualnie dodane osoby',
    },
    firstName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.firstName',
        defaultMessage: 'Imię',
    },
    lastName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.lastName',
        defaultMessage: 'Nazwisko',
    },
    role: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.role',
        defaultMessage: 'Funkcja',
    },
    availability: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.availability',
        defaultMessage: 'Dostępność',
    },
    description: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.description',
        defaultMessage: 'Opis',
    },
    visibleForGuests: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.visibleForGuests',
        defaultMessage: 'Widoczne dla parafian',
    },
    personCategory: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.personCategory',
        defaultMessage: 'Rola lub funkcja',
    },
    selectCategory: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.selectCategory',
        defaultMessage: 'Wybierz rolę lub funkcję',
    },
    subscriptionStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.subscriptionStepTitle',
        defaultMessage: 'Subskrypcja',
    },
    subscriptionDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.subscriptionDescription',
        defaultMessage: 'Wybierz plan, który chcesz uruchomić po zakończeniu konfiguracji.',
    },
    planPriceMonthly: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.planPriceMonthly',
        defaultMessage: 'Cena miesięczna',
    },
    month: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.month',
        defaultMessage: 'Miesiąc',
    },
    choosePlan: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.choosePlan',
        defaultMessage: 'Wybierz plan',
    },
    selectedPlan: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.selectedPlan',
        defaultMessage: 'Wybrany plan',
    },
    paymentStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.paymentStepTitle',
        defaultMessage: 'Dane karty',
    },
    paymentDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.paymentDescription',
        defaultMessage: 'Wpisz dane karty i adres rozliczeniowy. Dane są przetwarzane przez zabezpieczony protokół.',
    },
    accountAddressTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.accountAddressTitle',
        defaultMessage: 'Dane osoby/konta',
    },
    accountAddressDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.accountAddressDescription',
        defaultMessage: 'Uzupełnij adres osoby przypisanej do konta.',
    },
    invoiceDetailsTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.invoiceDetailsTitle',
        defaultMessage: 'Dane do faktury',
    },
    invoiceDetailsDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.invoiceDetailsDescription',
        defaultMessage: 'Jeśli chcesz otrzymywać faktury, możesz od razu uzupełnić dane. Ten krok jest opcjonalny.',
    },
    summaryStepTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryStepTitle',
        defaultMessage: 'Podsumowanie',
    },
    summaryDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryDescription',
        defaultMessage: 'Sprawdź dane przed uruchomieniem konta.',
    },
    summaryGroupName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryGroupName',
        defaultMessage: 'Nazwa parafii',
    },
    summaryGroupEmail: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryGroupEmail',
        defaultMessage: 'E-mail parafii',
    },
    summaryCategoriesList: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryCategoriesList',
        defaultMessage: 'Role i funkcje',
    },
    summaryPeopleCount: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryPeopleCount',
        defaultMessage: 'Liczba osób',
    },
    summarySubscriptionPlan: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summarySubscriptionPlan',
        defaultMessage: 'Wybrany plan',
    },
    summaryCardData: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryCardData',
        defaultMessage: 'Dane karty',
    },
    summaryAccountAddress: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryAccountAddress',
        defaultMessage: 'Adres osoby/konta',
    },
    sameAsAccountAddress: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.sameAsAccountAddress',
        defaultMessage: 'Takie same jak dane osoby/konta',
    },
    summaryInvoiceFullName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryInvoiceFullName',
        defaultMessage: 'Imię i nazwisko',
    },
    summaryInvoiceEmail: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryInvoiceEmail',
        defaultMessage: 'E-mail do faktury',
    },
    summaryInvoiceAddress: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryInvoiceAddress',
        defaultMessage: 'Adres',
    },
    summaryInvoiceCompanyName: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryInvoiceCompanyName',
        defaultMessage: 'Firma',
    },
    summaryInvoiceTaxId: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryInvoiceTaxId',
        defaultMessage: 'NIP',
    },
    summaryInvoiceEuVatId: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryInvoiceEuVatId',
        defaultMessage: 'VAT UE',
    },
    summaryNotProvided: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.summaryNotProvided',
        defaultMessage: 'Nie podano',
    },
    peopleCount: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.peopleCount',
        defaultMessage: '{count, plural, one {# osoba} few {# osoby} many {# osób} other {# osoby}}',
    },
    cardHiddenSummary: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.cardHiddenSummary',
        defaultMessage: 'Dane karty pozostają ukryte i nie są wyświetlane w podsumowaniu.',
    },
    submitFailedTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.submitFailedTitle',
        defaultMessage: 'Nie udało się zakończyć konfiguracji',
    },
    submitFailed: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.submitFailed',
        defaultMessage: 'Wystąpił błąd podczas zapisywania konfiguracji. Spróbuj ponownie.',
    },
    submitMissingData: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.submitMissingData',
        defaultMessage: 'Brakuje danych potrzebnych do zakończenia konfiguracji.',
    },
    paymentElementMissing: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.paymentElementMissing',
        defaultMessage: 'Nie udało się odczytać danych karty. Wróć do kroku płatności i spróbuj ponownie.',
    },
    billingAddressRequired: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.billingAddressRequired',
        defaultMessage: 'Uzupełnij poprawnie adres rozliczeniowy.',
    },
    paymentFailed: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.paymentFailed',
        defaultMessage: 'Nie udało się utworzyć metody płatności.',
    },
    exitModalHeading: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.exitModalHeading',
        defaultMessage: 'Co chcesz zrobić z konfiguracją?',
    },
    exitModalDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.exitModalDescription',
        defaultMessage: 'Możesz zapisać postęp i wrócić później. Jeśli wybierzesz wyjście bez zapisu karty, zapiszemy pozostałe dane konfiguracji.',
    },
    saveAndContinueLater: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.saveAndContinueLater',
        defaultMessage: 'Zapisz i wróć później',
    },
    exitWithoutSave: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupModal.exitWithoutSave',
        defaultMessage: 'Wyjdź bez zapisu',
    },
});

export default messages;
